import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

import { SalesOrderLineRequirement } from '../../../models';
import { TmsWebBaseEditCreateService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class SalesOrderLineRequirementService extends TmsWebBaseEditCreateService<
  SalesOrderLineRequirement,
  SalesOrderLineRequirement
> {
  public refreshDetails = new Subject<void>();

  constructor() {
    super('SalesOrderLineRequirement', $localize`Sales Order Line Requirement`);
  }

  createSalesOrderRequirements(
    salesOrderLineId: string,
    salesOrderLineRequirementId?: string,
  ): Observable<SalesOrderLineRequirement[]> {
    return this.httpService.get<SalesOrderLineRequirement[]>(
      `${this.apiUrl}/CreateSalesOrderRequirements/${salesOrderLineId}${
        salesOrderLineRequirementId ? `/${salesOrderLineRequirementId}` : ''
      }`,
    );
  }
}
